var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-speechbubble",class:[..._vm.className, `type-${_vm.type}`, `size-${_vm.size}`]},[_c('section',{staticClass:"bubble"},[_c('section',{staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.displayText)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }